import { render } from "./EvmToken.vue?vue&type=template&id=6ea88656"
import script from "./EvmToken.vue?vue&type=script&lang=js"
export * from "./EvmToken.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__